<div class="alert-container rounded-xl backdrop-blur-md border" [class]="getContainerClasses()">
  <div class="alert-icon">
    <mat-icon>{{ getIcon() }}</mat-icon>
  </div>
  <div class="alert-content">
    <ng-content select="[alert-title]"></ng-content>
    <ng-content select="[alert-message]"></ng-content>
  </div>
  <div class="alert-actions">
    <ng-content select="[slot=actions]"></ng-content>
    @if (dismissible) {
      <button
        type="button"
        class="close-btn"
        (click)="onDismiss()"
        aria-label="Dismiss">
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>
</div>